import { Grid, makeStyles, Typography } from "@material-ui/core";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useEffect, useState } from "react";
import News from "../../actions/News";
import { isAuth } from "../../actions/auth";

import { Alert } from "@material-ui/lab";
import { Document, Page, pdfjs } from "react-pdf";
import Popup from "../customHelpers/Popup";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const initialFValues = {
  body: "",
  title: "",
  author: "",
  editing: false,
  image: null,
  existingImage: null,
};

const allowedHeadlineTypes = ["image/avif", "image/webp", "image/jpeg"];
const headlineExtensionPattern = /\.(avif|webp|jpe?g)$/i;

const QuillModules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],
    ["image", "video", "link"],
    [{ header: 1 }, { header: 2 }, { header: [1, 2, 3, 4, 5, 6, false] }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ direction: "rtl" }], // text direction
    [{ size: ["small", "large", "huge", false] }], // custom dropdown
    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],
    ["clean"],
  ],
};
const QuillFormats = [
  "background",
  "bold",
  "color",
  "font",
  "code",
  "italic",
  "link",
  "size",
  "strike",
  "script",
  "underline",
  "blockquote",
  "header",
  "indent",
  "list",
  "align",
  "direction",
  "code-block",
  "formula",
  "image",
  "video",
];

const NewsForm = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  getAllNews,
  update,
  isCompany = false,
  companyId = null,
}) => {
  const [imageError, setImageError] = useState("");

  const { addNews, updateNews, userAddNews, updateCompanyNews } = News();

  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    if ("body" in fieldValues)
      temp.body =
        fieldValues.body.length != 0 && fieldValues.body != "<p><br></p>"
          ? ""
          : "The body of the news can not be empty.";
    if ("title" in fieldValues)
      temp.title =
        fieldValues.title.length != 0 ? "" : "This field is required.";
    if ("author" in fieldValues)
      temp.author =
        fieldValues.author.length != 0 ? "" : "This field is required.";

    setErrors({
      ...temp,
    });
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };
  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(recordForEdit || initialFValues, true, validate);

  useEffect(() => {
    if (recordForEdit != null) {
      setValues({
        ...recordForEdit,
        image: null,
        existingImage: recordForEdit.image || recordForEdit.headingImage || null,
      });
      setImageError("");
    }
  }, [recordForEdit, setValues]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setValues({ ...values, submitting: true });

      const formData = new FormData();
      formData.append("title", values.title);
      formData.append("body", values.body);
      formData.append("author", values.author);
      const selectedImage = values.image instanceof File ? values.image : null;
      if (selectedImage) {
        formData.append("image", selectedImage);
      }

      if (isCompany) {
        const user = isAuth();
        if (user?.email) formData.append("companyEmail", user.email);
        if (user?.name) formData.append("companyName", user.name);
        if (user?.description) formData.append("companyDescription", user.description || "");
        if (user?.logo) formData.append("companyLogo", user.logo || "");
      }

      const action = values.editing
        ? (isCompany ? updateCompanyNews(formData, values.Id) : updateNews(formData, values.Id))
        : (isCompany ? userAddNews(formData, companyId || "self") : addNews(formData));

      action.then((data) => {
        if (data.err) {
          setValues({ ...values, submitting: false });
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setOpenPopup(false);
        resetForm();
        setImageError("");
          // Call getAllNews with current page/limit or defaults
          if (getAllNews) {
            getAllNews();
          }
        }
      });
    }
  };
  const handleBody = (name, value) => ({
    target: {
      name,
      value,
    },
  });

  const handleHeadlineImageChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      setValues((prev) => ({ ...prev, image: null }));
      setImageError("");
      return;
    }
    const fileType = (file.type || "").toLowerCase();
    const isAllowedType =
      allowedHeadlineTypes.includes(fileType) ||
      headlineExtensionPattern.test(file.name || "");

    if (!isAllowedType) {
      setImageError("Headline image must be an AVIF, WEBP, or JPEG file.");
      setValues((prev) => ({ ...prev, image: null }));
      event.target.value = "";
      return;
    }

    setImageError("");
    setValues((prev) => ({
      ...prev,
      image: file,
      existingImage: null,
    }));
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Controls.Input
            name="title"
            label="Title"
            value={values.title}
            onChange={handleInputChange}
            error={errors.title}
          />
        </Grid>
        <Grid item xs={6}>
          <Controls.Input
            name="author"
            label="Author"
            value={values.author}
            onChange={handleInputChange}
            error={errors.author}
          />
        </Grid>
        <Grid item xs={12}>
          <div
            style={{
              margin: "10px 0",
              border: "1px solid #c4c4c4",
              borderRadius: "4px",
              padding: "10px",
            }}
          >
            <label
              style={{
                display: "block",
                color: "#666",
                marginBottom: "5px",
                fontSize: "0.9rem",
              }}
            >
              Headline Image
            </label>
            {values.existingImage && !values.image && (
              <div style={{ marginBottom: 8 }}>
                <Typography variant="caption" display="block">
                  Current headline image
                </Typography>
                <img
                  src={values.existingImage}
                  alt="Current headline"
                  style={{
                    width: "100%",
                    maxHeight: 200,
                    borderRadius: 4,
                    objectFit: "cover",
                    marginTop: 4,
                  }}
                />
              </div>
            )}
            <input
              type="file"
              accept="image/avif,image/webp,image/jpeg"
              onChange={handleHeadlineImageChange}
            />
            <Typography
              variant="caption"
              style={{ display: "block", marginTop: 6 }}
              color={imageError ? "error" : "textSecondary"}
            >
              {imageError
                ? imageError
                : "Allowed formats: AVIF, WEBP, or JPEG. Max size 5MB."}
            </Typography>
          </div>
        </Grid>


        <Grid item xs={12}>
          {" "}
          <ReactQuill
            modules={QuillModules}
            formats={QuillFormats}
            value={values.body}
            placeholder="what's on your mind"
            onChange={(e) => handleInputChange(handleBody("body", e))}
            theme="snow"
          />{" "}
          {errors.body && <Alert severity="error">{errors.body}</Alert>}
        </Grid>
        <Grid item xs={12}>
          <Controls.Button
            disabled={values.submitting ? true : false}
            text={
              values.editing == true
                ? values.submitting
                  ? "Editing..."
                  : "Edit"
                : values.submitting
                  ? "Publishing..."
                  : "Publish"
            }
            variant="contained"
            className="Button"
            type="submit"
          />
        </Grid>
      </Grid>
    </Form>
  );
};

export default NewsForm;
